import React, { useState } from 'react';
import './WorkHighlightsCarousel.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Image imports
import img1 from '../assets/galimg/gallery-1.png';
import img2 from '../assets/galimg/gallery-2.png';
import img3 from '../assets/galimg/gallery-3.png';
import img4 from '../assets/galimg/gallery-4.png';
import img5 from '../assets/galimg/gallery-5.png';
import img6 from '../assets/galimg/gallery-6.png';
import img7 from '../assets/galimg/gallery-7.png';
import img8 from '../assets/galimg/gallery-8.png';
import img9 from '../assets/galimg/gallery-9.png';
import img10 from '../assets/galimg/gallery-10.png';
import img11 from '../assets/galimg/gallery-vid-1.jpg';
import img12 from '../assets/galimg/gallery-vid-2.jpg';

// Video imports
import video1 from '../assets/galimg/gallery-vid-1.mp4';
import video2 from '../assets/galimg/gallery-vid-2.mp4';
import video3 from '../assets/galimg/gallery-vid-3.mp4';
import video4 from '../assets/galimg/gallery-vid-4.mp4';
import video6 from '../assets/galimg/gallery-vid-6.mp4';
import video5 from '../assets/galimg/gallery-vid-5.mp4';
import video7 from '../assets/galimg/gallery-vid-7.mp4';
import video8 from '../assets/galimg/gallery-vid-8.mp4';

const mediaItems = [
  { type: 'image', src: img1 },
  { type: 'image', src: img2 },
  { type: 'image', src: img3 },
  { type: 'video', src: video1, thumbnail: img11 },
  { type: 'image', src: img5 },
  { type: 'image', src: img6 },
  { type: 'video', src: video2, thumbnail: img12 },
  { type: 'image', src: img8 },
  { type: 'video', src: video3, thumbnail: img3 },
  { type: 'image', src: img10 },
  { type: 'video', src: video7, thumbnail: img9 },
  { type: 'image', src: img9 },
  { type: 'video', src: video4, thumbnail: img4 },
  { type: 'video', src: video8, thumbnail: img10 },
  { type: 'image', src: img4 },
  { type: 'video', src: video5, thumbnail: img5 },
  { type: 'image', src: img8 },
  { type: 'video', src: video6, thumbnail: img3 },
];

const groupSlides = (items, perSlide = 9) => {
  const grouped = [];
  for (let i = 0; i < items.length; i += perSlide) {
    grouped.push(items.slice(i, i + perSlide));
  }
  return grouped;
};

const WorkHighlightsCarousel = () => {
  const slides = groupSlides(mediaItems);
  const [popup, setPopup] = useState({ open: false, index: null });

  const handleMediaClick = (globalIndex) => {
    setPopup({ open: true, index: globalIndex });
  };

  const closePopup = () => {
    setPopup({ open: false, index: null });
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setPopup((prev) => ({
      ...prev,
      index: (prev.index - 1 + mediaItems.length) % mediaItems.length,
    }));
  };

  const showNext = (e) => {
    e.stopPropagation();
    setPopup((prev) => ({
      ...prev,
      index: (prev.index + 1) % mediaItems.length,
    }));
  };

  // Map each group/slide to global index for popup navigation
  let globalIdx = 0;

  return (
    <div className="wh-carousel-container">
      <div className="wh-carousel-header container">
        <h2 className="wh-carousel-title">Work Highlights</h2>
        <div className="wh-carousel-controls">
          <div className="wh-nav-btn swiper-button-prev">
            <span></span>
          </div>
          <div className="wh-nav-btn swiper-button-next">
            <span></span>
          </div>
        </div>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        pagination={{ clickable: true }}
        loop={true}
      >
        {slides.map((group, groupIdx) => (
          <SwiperSlide key={groupIdx}>
            <div className="wh-grid-wrapper container">
              {group.map((item, idx) => {
                const thisGlobalIdx = globalIdx;
                globalIdx++;
                return (
                  <div
                    className="wh-media-card"
                    key={idx}
                    onClick={() => handleMediaClick(thisGlobalIdx)}
                  >
                    <img
                      src={item.type === 'video' ? item.thumbnail : item.src}
                      alt={`Media ${thisGlobalIdx}`}
                    />
                    {item.type === 'video' && (
                      <div className="wh-play-icon">⯈</div>
                    )}
                  </div>
                );
              })}
            </div>
          </SwiperSlide>
        ))}
        <br /><br />
      </Swiper>

      {popup.open && (
        <div className="wh-video-popup-overlay" onClick={closePopup}>
          <div className="wh-video-popup-content" onClick={e => e.stopPropagation()}>
            <button className="wh-video-close-btn" onClick={closePopup}>×</button>
            <button className="wh-video-nav-btn wh-video-prev" onClick={showPrev}>&lt;</button>
            <button className="wh-video-nav-btn wh-video-next" onClick={showNext}>&gt;</button>
            {mediaItems[popup.index].type === 'video' ? (
              <video src={mediaItems[popup.index].src} controls autoPlay className="wh-video-player" style={{ maxWidth: '90vw', maxHeight: '80vh' }} />
            ) : (
              <img src={mediaItems[popup.index].src} alt="Gallery Large" className="wh-image-player" style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: 8 }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkHighlightsCarousel;
